import { ApiTableColumn } from '@e3dc-react/shell/Elements/ApiView/ApiView'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { getInstallationMissingIbnTableColumns } from '../utils'
import { Statement } from 'src/Libs/installations/types'

export interface InstallationMissingIbnTableColumns extends Statement {
  installationRequirements: unknown
}
export interface InstallationMissingIbnTableColumnsResult {
  tableColumnsMd: ApiTableColumn<InstallationMissingIbnTableColumns>[]
  tableColumnsSm: ApiTableColumn<InstallationMissingIbnTableColumns>[]
}

/*
 * provides table columns for an missing IBN installation table based on media breakpoints
 * Eg.:
 * const {  tableColumnsMd, tableColumnsSm  } = useInstallationMissingIbnTableColumns()
 * const tableColumns = downSm ? tableColumnsSm : tableColumnsMd
 *
 *  <ApiView<InstallationMissingIbnTableColumns>
 *     tableColumns={tableColumns}
 *     {...props}
 *   />
 */

export const useInstallationMissingIbnTableColumns = (): InstallationMissingIbnTableColumnsResult => {
  const { t } = useCustomTranslation()

  const { tableColumnsMd, tableColumnsSm } = getInstallationMissingIbnTableColumns(t)

  return { tableColumnsMd, tableColumnsSm }
}
